(function () {
  var chars = '!<>-_\\/[]{}—=+*^?#_____';

  function TS(el) {
    this.el = el; this.frameRequest = null; this.frame = 0; this.queue = [];
    this.update = this.update.bind(this);
  }
  TS.prototype.setText = function (newText) {
    var old = this.el.textContent, len = Math.max(old.length, newText.length), self = this;
    var promise = new Promise(function (res) { self.resolve = res; });
    this.queue = [];
    for (var i = 0; i < len; i++) {
      var start = Math.floor(Math.random() * 24);
      var end = start + Math.floor(Math.random() * 24);
      this.queue.push({ from: old[i] || '', to: newText[i] || '', start: start, end: end, char: null });
    }
    if (this.frameRequest) cancelAnimationFrame(this.frameRequest);
    this.frame = 0; this.update();
    return promise;
  };
  TS.prototype.update = function () {
    var output = '', complete = 0;
    for (var i = 0; i < this.queue.length; i++) {
      var q = this.queue[i];
      if (this.frame >= q.end) { complete++; output += q.to; }
      else if (this.frame >= q.start) {
        if (!q.char || Math.random() < 0.24) q.char = chars[Math.floor(Math.random() * chars.length)];
        var cls = Math.random() < 0.55 ? 'dud' : 'dud2';
        output += '<span class="' + cls + '">' + q.char + '</span>';
      } else output += q.from;
    }
    this.el.innerHTML = output;
    if (complete === this.queue.length) { if (this.resolve) this.resolve(); }
    else { this.frame++; this.frameRequest = requestAnimationFrame(this.update); }
  };

  function run(el, delay) {
    var final = (el.getAttribute('data-final') || el.textContent).trim();
    el.setAttribute('data-final', final);
    var ts = el._ts || (el._ts = new TS(el));
    setTimeout(function () { ts.setText(final); }, delay || 0);
  }

  function init() {
    var els = document.querySelectorAll('[data-scramble]');
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute('data-final', el.textContent.trim()); });
    // decode when the element scrolls into view (fires immediately if already on screen)
    if ('IntersectionObserver' in window) {
      var seen = 0;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.target._decoded) return;
          entry.target._decoded = true;
          run(entry.target, (seen++) * 240);
          io.unobserve(entry.target);
        });
      }, { threshold: 0.35 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el, idx) { run(el, idx * 240); });
    }
    // re-decode the headword on hover
    document.querySelectorAll('.term[data-scramble]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { run(el, 0); });
    });
    // occasional ambient re-glitch of the headword so it feels alive
    var term = document.querySelector('.term[data-scramble]');
    if (term) setInterval(function () { if (!document.hidden) run(term, 0); }, 14000);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
